import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable()
export class ModalConfiguracionExtraPreguntaService
  implements RequestCRUD<any, ResponseServiceModel> {
  private API_URL;
  private handleError: HandleError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.handleError = httpErrorHandler.createHandleError("PreguntaEncuesta");
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/`)
      .pipe(retry(2));
  }

  update(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(`${this.API_URL}/`, entry)
      .pipe(retry(2));
  }

  create(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/`, entry)
      .pipe(retry(2));
  }

  delete(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .delete<ResponseServiceModel>(`${this.API_URL}/`)
      .pipe(retry(2));
  }

  createValidate(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/PreguntaEncuestaAdministrador/Validar_Sintaxis`, entry)
      .pipe(retry(2));
  }

  getModulosSeccionesPreguntas(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/PreguntaEncuestaAdministrador/ObtenerModulosSeccionesPreguntas`, entry)
      .pipe(retry(2));
  }

  getCondicion(entry: any, isAditional: boolean): Observable<ResponseServiceModel> {
    const endPoint = isAditional ?
      "PreguntaAdicionalEncuestaCondicionAdministrador" :
      "PreguntaEncuestaCondicion";

    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/${endPoint}/${entry}`)
      .pipe(retry(2));
  }

  createCondicionYBloqueo(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/PreguntaEncuestaListaValor/crear`, entry)
      .pipe(retry(2));
  }
}
